const STATUS_LABELS = {
    processing: 'Выполняется',
    succeeded: 'Выполнено',
    failed: 'Не выполнено',
    requires_attention: 'Требует внимания',
};
const KIND_LABELS = {
    admin_credit: 'Начисление на баланс',
    admin_debit: 'Списание с баланса',
    balance_zero: 'Обнуление баланса',
    debt_forgiven: 'Обнуление отрицательного баланса',
    account_activate: 'Возобновление подписки',
    account_deactivate: 'Приостановка подписки',
    locations_changed: 'Изменение локаций',
    device_number_changed: 'Изменение числа устройств',
    payment_link_created: 'Ссылка на оплату создана',
    user_deletion: 'Удаление пользователя',
    // Older Users deployments used these values. Keep them readable while
    // environments roll forward independently.
    balance_credit: 'Начисление на баланс',
    balance_debit: 'Списание с баланса',
    balance_zero_legacy: 'Обнуление баланса',
    balance_forgive_debt: 'Обнуление отрицательного баланса',
    locations_update: 'Изменение локаций',
    device_number_update: 'Изменение числа устройств',
    deletion: 'Удаление пользователя',
};
const STEP_LABELS = {
    adjustment_audit: 'Запись корректировки в платёжном сервисе',
    balance_notification: 'Уведомление пользователю об изменении баланса',
    provisioning: 'Подготовка доступа по подписке',
    panel_set_active: 'Изменение состояния подписки',
    panel_set_expire: 'Обновление срока подписки',
    subscription_projection: 'Пересчёт подписки',
    authorization: 'Проверка прав и разрешение на удаление',
    globalauth_finished: 'Завершение удаления в GlobalAuth',
    project_request: 'Запрос очистки от GlobalAuth',
    payments: 'Очистка данных в платежах',
    locations: 'Очистка данных локаций',
    news: 'Очистка данных новостей',
    panel_delete: 'Удаление доступа по подписке',
    local_cleanup: 'Удаление профиля пользователя',
    project_result: 'Отправка результата очистки в GlobalAuth',
};
const STEP_STATUS_LABELS = {
    pending: 'Ожидает',
    succeeded: 'Выполнено',
    failed: 'Ошибка',
};
const OPERATION_CODE_MESSAGES = {
    no_available_contact: 'Уведомление не отправлено: у пользователя нет доступных контактов.',
    account_created: 'Доступ по подписке создан.',
    subscription_projection_unavailable: 'Пересчёт подписки временно недоступен и будет повторён.',
    subscription_projection_failed: 'Пересчёт подписки не удался. Нужна ручная проверка.',
    subscription_projection_target_unavailable: 'Пересчёт невозможен: пользователь недоступен, удаляется или на балансе недостаточно средств.',
    self_deletion_forbidden: 'Нельзя удалить самого себя.',
    deletion_forbidden: 'Недостаточно прав: поддержка может удалять только обычных пользователей.',
    actor_unavailable: 'Ваша учётная запись недоступна для этого действия.',
    target_not_found: 'Пользователь не найден в GlobalAuth.',
    deletion_in_progress: 'Удаление этого пользователя уже выполняется.',
    operation_conflict: 'Конфликт данных операции. Обратитесь к разработчикам.',
    source_not_registered: 'Сервис-источник не зарегистрирован в GlobalAuth.',
    registry_unclassified: 'В реестре есть сервис без настройки очистки.',
    participant_not_ready: 'Один из обязательных сервисов не готов к удалению.',
    deletion_publication_unavailable: 'Не удалось отправить запрос на удаление. Запустите новое действие позже.',
    operation_cancelled_for_deletion: 'Шаг отменён из-за удаления пользователя.',
};
const TECHNICAL_DELETION_CODES = new Set([
    'coordinator_not_registered',
    'invalid_broker_address',
    'queue_namespace_collision',
    'reserved_source',
    'legacy_deletion_operation',
    'source_not_coordinator',
]);
export function operationStatusView(status) {
    const label = STATUS_LABELS[status];
    return label ? { label } : { label: 'Неизвестное состояние', raw: status };
}
export function operationKindLabel(kind) {
    return KIND_LABELS[kind] ?? kind;
}
export function operationStepLabel(name) {
    return STEP_LABELS[name] ?? name;
}
export function operationStepStatusView(status) {
    const label = STEP_STATUS_LABELS[status];
    return label ? { label } : { label: 'Неизвестное состояние', raw: status };
}
export function operationCodeMessage(code) {
    if (code == null)
        return null;
    if (TECHNICAL_DELETION_CODES.has(code)) {
        return 'Удаление отклонено из-за технической ошибки конфигурации.';
    }
    return OPERATION_CODE_MESSAGES[code] ?? null;
}
export function isDeletionOperation(kind) {
    return kind === 'user_deletion' || kind === 'deletion';
}
export function validateReason(value) {
    const reason = value.trim();
    if (!reason)
        return 'Укажите причину';
    if (reason.length > 500)
        return 'Причина должна быть не длиннее 500 символов';
    return null;
}
export function parseBalanceAmount(value) {
    const normalized = value.trim();
    if (!/^\d+$/.test(normalized))
        return null;
    const amount = Number(normalized);
    return Number.isSafeInteger(amount) && amount >= 1 && amount <= 1_000_000 ? amount : null;
}
export function paymentAmountError(value, custom, precision) {
    if (!custom)
        return 'Своя сумма недоступна для этой кассы';
    const normalized = value.trim().replace(',', '.');
    if (!normalized)
        return 'Укажите сумму';
    if (!/^\d+(?:\.\d+)?$/.test(normalized) || Number(normalized) <= 0) {
        return 'Введите сумму больше нуля';
    }
    const decimals = normalized.split('.')[1]?.length ?? 0;
    if (decimals > precision)
        return `Не больше ${precision} знаков после запятой`;
    const amount = Number(normalized);
    if (amount < Number(custom.min_amount) || amount > Number(custom.max_amount)) {
        return `Сумма должна быть от ${custom.min_amount} до ${custom.max_amount}`;
    }
    return null;
}
function createIdempotencyKey() {
    const cryptoApi = globalThis.crypto;
    if (typeof cryptoApi.randomUUID === 'function')
        return cryptoApi.randomUUID();
    const bytes = cryptoApi.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
export function createOperationIntent(command, uuid = createIdempotencyKey()) {
    const reason = command.reason?.trim();
    const common = { idempotencyKey: uuid };
    switch (command.kind) {
        case 'balance-credit':
            return {
                ...common,
                path: 'balance/credit',
                body: { amount: command.amount, reason },
            };
        case 'balance-debit':
            return {
                ...common,
                path: 'balance/debit',
                body: { amount: command.amount, reason },
            };
        case 'balance-zero':
            return { ...common, path: 'balance/zero', body: { reason } };
        case 'balance-forgive-debt':
            return { ...common, path: 'balance/forgive-debt', body: { reason } };
        case 'subscription-activate':
            return { ...common, path: 'account/activate', body: reason ? { reason } : {} };
        case 'subscription-deactivate':
            return { ...common, path: 'account/deactivate', body: reason ? { reason } : {} };
        case 'deletion':
            return {
                ...common,
                path: 'deletion',
                body: { scope: command.scope, reason },
            };
    }
}
function allLocations(catalog) {
    const byId = new Map();
    for (const location of [
        ...catalog.groups.flatMap((group) => group.locations),
        ...catalog.locations,
    ]) {
        const current = byId.get(location.id);
        if (!current) {
            byId.set(location.id, location);
            continue;
        }
        const options = new Map(current.options.map((option) => [option.location_option_id, option]));
        for (const option of location.options)
            options.set(option.location_option_id, option);
        byId.set(location.id, { ...current, ...location, options: [...options.values()] });
    }
    return [...byId.values()];
}
function sorted(ids) {
    return [...new Set(ids)].sort((a, b) => a - b);
}
export function selectedOptionIds(catalog) {
    return sorted(allLocations(catalog).flatMap((location) => location.options
        .filter((option) => option.is_selected)
        .map((option) => option.location_option_id)));
}
function selectedLocationCount(locations, selected) {
    return locations.filter((location) => location.options.some((option) => selected.has(option.location_option_id))).length;
}
export function changeLocationSelection(catalog, selected, change) {
    const locations = allLocations(catalog);
    const location = locations.find((item) => item.id === change.locationId);
    const before = new Set(selected);
    const next = new Set(selected);
    const unchanged = (error) => ({
        options: sorted(before),
        error,
        removedUnavailable: false,
    });
    if (!location)
        return unchanged('Локация не найдена');
    let removedUnavailable = false;
    if (change.type === 'location') {
        if (change.selected) {
            const required = location.options.filter((option) => option.is_default);
            const blockedRequired = required.some((option) => option.is_available === false && !before.has(option.location_option_id));
            if (blockedRequired)
                return unchanged('Обязательная опция этой локации недоступна');
            if (required.length === 0)
                return unchanged('У локации нет доступных обязательных опций');
            for (const option of required)
                next.add(option.location_option_id);
        }
        else {
            for (const option of location.options) {
                if (next.delete(option.location_option_id) && option.is_available === false) {
                    removedUnavailable = true;
                }
            }
        }
    }
    else {
        const option = location.options.find((item) => item.location_option_id === change.optionId);
        if (!option)
            return unchanged('Опция не найдена');
        if (change.selected) {
            if (option.is_available === false && !before.has(option.location_option_id)) {
                return unchanged('Эта опция больше недоступна');
            }
            next.add(option.location_option_id);
            for (const required of location.options) {
                if (required.is_default && required.is_available !== false) {
                    next.add(required.location_option_id);
                }
            }
        }
        else {
            if (option.is_default) {
                return unchanged('Обязательную опцию нельзя отключить отдельно от локации');
            }
            next.delete(option.location_option_id);
            removedUnavailable = option.is_available === false && before.has(option.location_option_id);
        }
    }
    if (selectedLocationCount(locations, next) === 0) {
        return unchanged('Нужно оставить хотя бы одну локацию');
    }
    return { options: sorted(next), error: null, removedUnavailable };
}
